module.exports = __webpack_public_path__ + "media/images/sportswear-a56e785444f1ecf5a4ea60f50299cc03.png";